package com.wintermar.inspection.core.ui.component.datetime.util

import androidx.compose.material3.ExperimentalMaterial3Api
import androidx.compose.material3.SelectableDates
import kotlinx.datetime.TimeZone
import kotlinx.datetime.toLocalDateTime
import kotlin.time.Clock
import kotlin.time.ExperimentalTime

@OptIn(ExperimentalMaterial3Api::class, ExperimentalTime::class)
object PastAndCurrentDates : SelectableDates {

    override fun isSelectableDate(utcTimeMillis: Long): Boolean {
        // Only allow dates that are less than or equal to the current time
        val now = Clock.System.now().toEpochMilliseconds()
        return utcTimeMillis <= now
    }

    override fun isSelectableYear(year: Int): Boolean {
        // Only allow current or past years
        val currentYear = Clock.System.now().toLocalDateTime(TimeZone.currentSystemDefault()).year
        return year <= currentYear
    }
}
